import React from "react";
import {useTranslation} from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import HelpModal from "./HelpModal";
import { FiHome, FiUsers, FiDatabase, FiShoppingCart, FiFileText } from 'react-icons/fi';
import './header.css';


function Header() {
    const {t, i18n} = useTranslation()
    const location = useLocation();
    const currentPath = location.pathname;

    // Soft cross-fade: dim+blur the page, swap the language at the trough,
    // then ease back. The active-button class comes from i18n.language —
    // React handles it via re-render. We deliberately don't touch the DOM
    // ourselves: an earlier version did manual classList.add/remove which
    // raced with React's reconciliation and produced an "every other click"
    // bug where the active state desynced from the actual language.
    const change_lang = (lang_name) => {
        if (i18n.language === lang_name) return;
        const root = document.querySelector('.App.container') || document.body;
        root.classList.add('lang-switching');
        window.setTimeout(() => {
            i18n.changeLanguage(lang_name).finally(() => {
                window.requestAnimationFrame(() => {
                    root.classList.remove('lang-switching');
                });
            });
        }, 220);
    };

    // /biobanks is intentionally NOT in this list — it's reachable only via
    // the "show similar studies" entry point on the data pages, not from the
    // top nav. Don't re-add it without confirming with product.
    const navItems = [
        { path: '/', icon: FiHome, label: 'menu_button' },
        { path: '/patients', icon: FiUsers, label: 'patient_button' },
        { path: '/assays', icon: FiDatabase, label: 'assay_button' },
        { path: '/order', icon: FiShoppingCart, label: 'order_button' },
        { path: '/documents', icon: FiFileText, label: 'documents_title' },
    ];

    return (
        <nav className="main-nav">
            <div className="nav-links">
                {navItems.map(item => {
                    const Icon = item.icon;
                    const isActive = currentPath === item.path;
                    return (
                        <Link
                            key={item.path}
                            to={item.path}
                            className={`nav-item ${isActive ? 'active' : ''}`}
                        >
                            <Icon size={18} />
                            <span>{t(item.label)}</span>
                        </Link>
                    );
                })}
                <HelpModal />
            </div>
            <div className="nav-lang">
                <button
                    id="ru-btn"
                    type="button"
                    className={`lang-btn ${i18n.language === 'ru' ? 'active' : ''}`}
                    onClick={() => change_lang('ru')}
                >
                    RU
                </button>
                <button
                    id="en-btn"
                    type="button"
                    className={`lang-btn ${i18n.language === 'en' ? 'active' : ''}`}
                    onClick={() => change_lang('en')}
                >
                    EN
                </button>
            </div>
        </nav>
    )
}


export default Header
